// 프로토타입의 LOG_DATA / QUARANTINE_DATA / ACTIVITY_LOG 시드

export type LogStatus = 'safe' | 'quarantine' | 'blocked';

export interface LogRow {
  fid: string;
  name: string;
  size: string;
  policy: string;
  project: string;
  engines: string;
  status: LogStatus;
  time: string;
}

export const LOG_DATA: LogRow[] = [
  { fid: 'f_a3f8b2c1', name: 'document_v2.pdf', size: '2.4 MB', policy: 'default', project: 'vibem-prod', engines: '✓ clamav · ✓ yara', status: 'safe', time: '14:32:18' },
  { fid: 'f_b2c1d9e5', name: 'profile_video.mp4', size: '128 MB', policy: 'media-only', project: 'vibem-prod', engines: '✓ clamav', status: 'safe', time: '14:18:05' },
  { fid: 'f_c1d9e4f5', name: 'install.exe', size: '15 MB', policy: 'default', project: 'vibelog-stage', engines: '⊘ 정책', status: 'blocked', time: '13:55:41' },
  { fid: 'f_d9e4f5a3', name: 'contract_2026.docx', size: '892 KB', policy: 'default', project: 'vibem-prod', engines: '✓ clamav · ✓ yara', status: 'safe', time: '13:41:22' },
  { fid: 'f_e4f5a3b2', name: 'malware.zip', size: '2.1 MB', policy: 'default', project: 'vibelog-stage', engines: '✗ clamav (Trojan)', status: 'quarantine', time: '13:20:11' },
  { fid: 'f_f5a3b2c1', name: 'macro_doc.xlsm', size: '3.7 MB', policy: 'strict', project: 'vibeagent-dev', engines: '✗ yara (VBA)', status: 'quarantine', time: '12:58:44' },
  { fid: 'f_a3b2c1d9', name: 'minutes.docx', size: '156 KB', policy: 'default', project: 'vibem-prod', engines: '✓ clamav · ✓ yara', status: 'safe', time: '12:30:19' },
  { fid: 'f_b2c1d9e4', name: 'payload.pdf', size: '8.9 MB', policy: 'default', project: 'vibelog-stage', engines: '✗ yara (JS)', status: 'quarantine', time: '11:47:33' },
];

export interface QuarantineRow {
  id: string;
  fid: string;
  name: string;
  size: string;
  project: string;
  client_id: string;
  uploadedBy: string;
  time: string;
  threat: string;
  engine: string;
  threatLevel: 1 | 2 | 3 | 4;
  reason: string;
  hash: string;
}

export const QUARANTINE_DATA: QuarantineRow[] = [
  {
    id: 'Q001', fid: 'f_e4f5a3b2',
    name: 'malware.zip', size: '2.1 MB',
    project: 'vibelog-stage', client_id: 'fg_live_abc...',
    uploadedBy: 'unknown (IP: 192.168.1.45)',
    time: '2026-05-14 13:20:11',
    threat: 'Win.Trojan.Agent-XXXXX', engine: 'ClamAV',
    threatLevel: 4,
    reason: 'ClamAV 시그니처 매칭으로 "Win.Trojan.Agent-XXXXX" 변종이 탐지되었습니다. 이 악성코드는 원격 코드 실행 페이로드를 포함하며 시스템 레지스트리 수정을 시도합니다.',
    hash: 'sha256: a3f8b2c1d9e4f56789abcdef0123456789abcdef0123456789abcdef01234567',
  },
  {
    id: 'Q002', fid: 'f_f5a3b2c1',
    name: 'macro_doc.xlsm', size: '3.7 MB',
    project: 'vibeagent-dev', client_id: 'fg_live_xyz...',
    uploadedBy: 'jung.ah (인증된 내부 사용자)',
    time: '2026-05-14 12:58:44',
    threat: 'VBA 매크로 코드 포함', engine: 'YARA (rule: office_vba_detect)',
    threatLevel: 2,
    reason: '파일 내부에 실행 가능한 VBA 매크로가 발견되었습니다. 매크로 자동 격리 정책에 의해 처리되었습니다. 업로더가 신뢰할 수 있는 내부 사용자이므로 검토 후 허용 가능합니다.',
    hash: 'sha256: 7d9a1b3c5e2f8a4b6c8d1e3f5a7c9b2d4e6f8a1c3e5b7d9f2a4c6e8b1d3f5a7c',
  },
  {
    id: 'Q003', fid: 'f_b2c1d9e4_v2',
    name: 'payload.pdf', size: '8.9 MB',
    project: 'vibelog-stage', client_id: 'fg_live_abc...',
    uploadedBy: 'anon (미인증)',
    time: '2026-05-14 11:47:33',
    threat: 'PDF 내장 JavaScript 코드', engine: 'YARA + ClamAV',
    threatLevel: 3,
    reason: 'PDF 파일 내부에 의심스러운 JavaScript 페이로드가 임베드되어 있습니다. 외부 서버 통신을 시도할 수 있어 미인증 사용자의 경우 삭제를 권장합니다.',
    hash: 'sha256: 2b5f9e1d8c3a7f6b4d8e2c1a5f9b3e7d6a8c2b4f1e5d9a3c7b6f2e8d4a1c5b9f',
  },
];

export type ActivityType = 'green' | 'red' | 'yellow' | 'blue';
export interface ActivityRow { time: string; type: ActivityType; html: string }

export const ACTIVITY_LOG: ActivityRow[] = [
  { time: '14:32:18', type: 'green', html: '<strong>vibem-prod</strong>에서 <code>document_v2.pdf</code> 검사 완료 — 통과 (1.2초)' },
  { time: '14:18:05', type: 'green', html: '<strong>vibem-prod</strong>에서 <code>profile_video.mp4</code> 검사 완료 — 통과 (4.8초, 128MB)' },
  { time: '13:55:41', type: 'red', html: '<strong>vibelog-stage</strong>에서 <code>install.exe</code> 차단 — 정책 위반(blocked extension)' },
  { time: '13:41:22', type: 'green', html: '<strong>vibem-prod</strong>에서 <code>contract_2026.docx</code> 검사 통과' },
  { time: '13:20:11', type: 'red', html: '<strong>vibelog-stage</strong>에서 <code>malware.zip</code> 격리 — Win.Trojan.Agent 탐지' },
  { time: '12:58:44', type: 'yellow', html: '<strong>vibeagent-dev</strong>에서 <code>macro_doc.xlsm</code> 격리 — VBA 매크로 감지' },
  { time: '12:30:19', type: 'green', html: '<strong>vibem-prod</strong>에서 <code>minutes.docx</code> 검사 통과' },
  { time: '11:47:33', type: 'red', html: '<strong>vibelog-stage</strong>에서 <code>payload.pdf</code> 격리 — PDF 내 JS 임베드' },
  { time: '11:22:05', type: 'blue', html: 'ClamAV DB 자동 업데이트 완료 — 신규 시그니처 1,247개 추가' },
  { time: '10:15:00', type: 'blue', html: '서비스 시작 — ClamAV + YARA + Redis Queue 정상 가동' },
];

export interface OverviewLog { time: string; type: ActivityType; html: string }

export const OVERVIEW_LOG: OverviewLog[] = [
  { time: '14:32', type: 'green', html: '<strong>vibem-prod</strong>에서 <code>file_a3f8b2.pdf</code> 검사 통과' },
  { time: '14:18', type: 'red', html: '<strong>vibelog-stage</strong>에서 <code>malware.zip</code> 격리 처리' },
  { time: '13:55', type: 'yellow', html: '정책 <code>strict</code> 적용된 .exe 차단' },
  { time: '11:22', type: 'blue', html: 'ClamAV DB 자동 업데이트 (시그니처 +1,247)' },
  { time: '10:15', type: 'green', html: '서비스 시작 — 모든 엔진 정상' },
];
